import styled from 'styled-components';
import { Input, Select } from '@material-ui/core';

export const NotesSelect = styled(Select)`
  min-width: 200px;
  align-self: flex-start;
`;
export const NotesContainer = styled.div`
  padding: 20px;
`;

export const NotesInput = styled(Input)`
  min-width: 400px;
  min-height: 90px;
`;
